<script setup lang="ts">
import { useCoverLetter } from '../../model/cover-letter/cover-letter.hooks'
import DropzoneContainer from '../upload/DropzoneContainer.vue'

defineOptions({
  name: 'UploadCoverLetter',
})

const {
  mode,
  coverLetter,
  setCoverLetter,
} = useCoverLetter()

const dropzoneRef = useTemplateRef<InstanceType<typeof DropzoneContainer>>('dropzoneRef')

const resetFiles = (): void => {
  dropzoneRef.value?.resetFiles()
}

defineExpose({
  resetFiles,
})
</script>

<template>
  <div class="cover-letter">
    <DropzoneContainer
      ref="dropzoneRef"
      :mode="mode"
      :value="coverLetter"
      @click:drop="(acceptFiles) => setCoverLetter(acceptFiles)"
    />
  </div>
</template>
